<template>
    <v-dialog v-model="showJobPreprocessDialog"
            persistent
            min-width="80%"
            min-height="80%"
            width="auto">
        <v-card v-if="preprocessJob">
            <v-toolbar theme="dark">
                <v-toolbar-title>Confirm {{ typeVerb }} of {{ preprocessJob.name }}</v-toolbar-title>
                <v-btn icon="mdi-close"
                       @click="showJobPreprocessDialog = false"></v-btn>
            </v-toolbar>
            <v-card-text>
                <v-select label="Supervisor"
                          v-model="supervisor"
                          :items="supervisors"></v-select>
                <v-textarea label="Material Location" v-model="location" :hint="`Please give a description of where the material is after the ${ typeVerb } is complete.`"></v-textarea>
                <v-alert icon="mdi-alert-decagram-outline"
                         class="my-2"
                         v-if="completeErrors.length > 0"
                         type="warning">
                    <ul class="small-text">
                        <li :key="error" v-for="error in completeErrors">{{ error }}</li>
                    </ul>
                </v-alert>
            </v-card-text>
            <v-card-actions class="d-flex justify-end">
                <v-btn @click="save"
                       :loading="preprocessSaving"
                       :disabled="completeErrors.length > 0"
                       prepend-icon="mdi-check-circle"
                       color="success">
                    SAVE {{ typeVerb ? typeVerb.toUpperCase() : '' }}
                </v-btn>
                <v-btn variant="tonal" @click="showJobPreprocessDialog = false" :disabled="preprocessSaving">
                    CANCEL
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<style scoped lang="scss">
    @import '../../../styles/smart.scss'
</style>
<script>
    import { mapActions, mapState } from "vuex";
    function initialState() {
        return {
            saving: false,
            loading: false,
            location: '',
            supervisor: '',
            supervisors: ['John', 'Ina', 'Faiaia', 'Tafa', 'Jack', 'Tuvao', 'Cori']
        };
    }
    export default {
        name: "SmartPreprocessDialog",
        data: function () {
            return initialState();
        },
        mounted: function () {
        },
        props: {
        },
        methods: {
            ...mapActions([
                "showErrorSnack",
                "showSuccessSnack",
                "saveSmartPreprocessed"
            ]),
            reset: function () {
                Object.assign(this.$data, initialState());
            },
            resetInput() {
                this.location = '';
                this.supervisor = '';
            },
            save() {
                this.saveSmartPreprocessed({ job: this.preprocessJob, date: this.$dayjs().format('YYYY-MM-DD'), location: this.location, supervisor: this.supervisor, type: this.preprocessType });
            }
        },
        computed: {
            ...mapState({
                preprocessJob: (state) => state.smart.preprocessJob,
                preprocessType: (state) => state.smart.preprocessType,
                preprocessSaving: (state) => state.smart.preprocessSaving
            }),
            showJobPreprocessDialog: {
                get() {
                    return this.$store.state.smart.showJobPreprocessDialog
                },
                set(value) {
                    this.$store.commit('setShowJobPreprocessDialog', value)
                }
            },
            completeErrors() {
                let errors = [];
                if (!this.location || this.location.length == 0) {
                    errors.push('Location required');
                }
                if (!this.supervisor || this.supervisor.length == 0) {
                    errors.push('Supervisor required');
                }
                return errors;
            },
            typeVerb() {
                if (this.preprocessType === this.$constants.jobs.PREPRO_PRETREAT) {
                    return 'Pretreat';
                } else if (this.preprocessType === this.$constants.jobs.PREPRO_BLASTING) {
                    return 'Blast';
                } else if (this.preprocessType === this.$constants.jobs.PREPRO_STRIPPING) {
                    return 'Strip';
                } else {
                    return '';
                }
            }
        },
        watch: {
            preprocessJob: {
                handler: function () {
                    if (this.preprocessJob) {
                        this.resetInput();
                    }
                }
            }
        }
    };
</script>